define('common/ko/extension/delay',['underscore', 'knockout', 'common/tools'], function (_, ko, tools) {
    ko.extenders.delay = function(target, conf) {
        var delay = conf;
        var delayed = ko.observable(target.peek());
        var queue = new tools.PriorityQueue({low: true});

        var scheduledDequeue;
        var dequeue = function() {
            if (scheduledDequeue || !queue.size()) return;
            var now = new Date().getTime();
            while(now >= queue.top().t) {
                delayed(queue.pop().v);
                if (!queue.size()) return;
            }
            scheduledDequeue = setTimeout(function() {
                scheduledDequeue = undefined;
                dequeue();
            }, queue.top().t - now);
        };
        target.subscribe(function(value) {
            var publishTime = (new Date().getTime()) + ko.unwrap(delay);
            while(queue.peekLast() && queue.peekLast().t >= publishTime) {
                queue.popLast();
                clearTimeout(scheduledDequeue);
                scheduledDequeue = undefined;
            }
            queue.push({v: value, t: publishTime}, publishTime);
            dequeue();
        });

        return delayed;
    };
});

